import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=22b8cde2&"
import script from "./Survey.vue?vue&type=script&lang=js&"
export * from "./Survey.vue?vue&type=script&lang=js&"
import style0 from "./Survey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports